import { useEffect, useState } from 'react';

import Reducer from '../modules/reducers/Reducer';
import * as api from '../lib/api/api';
import { ERROR_REFRESH, ERROR_RETRY } from '../lib/Error';

export const useWriteReview = ({ id, type = null }) => {
  const reviewCategoryType =
    type === 'before' ? 'BABYFACE_BEFORE_BIRTH' : 'BABYFACE_AFTER_BIRTH';
  const [state, setValue, onChange, setValueAll] = Reducer(
    REVIEW_WRITE_INITIAL_STATE,
  );

  useEffect(() => {
    type === null
      ? onGetDetailReview()
      : api
          .getPurchasedInfo({ purchasedItemId: id, reviewCategoryType })
          .then((response) => {
            const { itemName, createDateTime } = response.data;
            setValueAll({
              object: {
                itemName,
                createDateTime,
              },
            });
          });
    api.getThumbnail({ name: reviewCategoryType }).then((response) => {
      setValue({
        name: 'thumbnail',
        value: response.data.thumbnail.storageUri,
      });
    });
    api.getPurchasedImage({ purchasedItemId: id }).then((response) => {
      setValue({ name: 'thumbnail', value: response.data });
    });
  }, []);

  const onGetDetailReview = () => {
    const id = this.props.match.params.id;
    api.getDetailReview({ id }).then((response) => {
      const {
        purchasedItemInfo: { itemName },
        facetImage,
        reviewImages,
        blogUrl,
        communityUrl,
        facebookUrl,
        instagramUrl,
        text,
        star,
        createDateTime,
      } = response.data;
      setValueAll({
        object: {
          itemName,
          blogUrl,
          communityUrl,
          facebookUrl,
          instagramUrl,
          text,
          createDateTime,
          rate: star,
          star,
          reviewImages:
            reviewImages.length > 5 ? reviewImages.slice(0, 5) : reviewImages,
          storageUri: facetImage === null ? '' : facetImage.image.storageUri,
        },
      });
    });
  };

  const onAddImageList = (e) => {
    if (
      reviewImages.length + defaultImages.length + e.target.files.length >
      5
    ) {
      alert('이미지는 최대 5장까지 올릴 수 있습니다.');
    } else {
      for (var i = 0; i < e.target.files.length; i++) {
        let reader = new FileReader();
        let file = e.target.files[i];
        reader.readAsDataURL(file);
        reader.onload = () => {
          setValueAll({
            object: {
              reviewImages: [...reviewImages, file],
              previewReviewImages: [...previewReviewImages, reader.result],
            },
          });
        };
      }
    }
  };

  const onCreateReview = () => {
    const defaultImageIds = defaultImages.length > 0 ? defaultImages[0].id : '';
    if (state.text.length > 20) {
      if (defaultImages.length + reviewImages.length >= 2) {
        setValue({ name: 'isLoading', value: true });

        const fd = new FormData();
        for (var i = 0; i < reviewImages.length; i++) {
          fd.append('filesToUpload', reviewImages[i], reviewImages[i].name);
        }
        fd.append(
          'review',
          new Blob(
            [
              JSON.stringify({
                star,
                text,
                blogUrl,
                communityUrl,
                facebookUrl,
                instagramUrl,
                marketingAgree,
              }),
            ],
            {
              type: 'application/json',
            },
          ),
        );
        (type === null
          ? api
              .putReview({ id, reviewImageIdsToDelete, fd })
              .then((response) => {
                alert('수정이 완료되었습니다.');
                this.handleGetDetailReview();
              })
          : api.postReview({
              fd,
              defaultImageIds,
              purchasedItemId: id,
              reviewCategoryType,
            })
        )
          .then(() => {
            setValue({ name: 'toMypage', value: true });
          })
          .catch((error) => {
            alert(ERROR_RETRY);
          })
          .finally(() => setValue({ name: 'isLoading', value: false }));
      } else {
        alert('사진을 2장 이상 첨부해주세요.');
      }
    } else {
      alert('후기를 20자 이상 작성해주세요.');
    }
  };

  const onDeleteDefaultImage = (id) => {
    const nextImages = defaultImages.filter(
      (defaultImage) => defaultImage.id !== id,
    );
    setValueAll({
      object: {
        defaultImages: nextImages,
        reviewImageIdsToDelete:
          reviewImageIdsToDelete === '' ? id : `${reviewImageIdsToDelete},id`,
      },
    });
  };

  const onDeleteAddImage = (index) => {
    const nextImages = reviewImages
      .slice(0, index)
      .concat(reviewImages.slice(index + 1, reviewImages.length));
    const nextPreviewImages = previewReviewImages
      .slice(0, index)
      .concat(previewReviewImages.slice(index + 1, previewReviewImages.length));
    setValueAll({
      object: {
        reviewImages: nextImages,
        previewReviewImages: nextPreviewImages,
      },
    });
  };

  const onMouseOver = (e) => {
    setValue({ name: 'rate', value: Number(e.target.id) });
  };

  const onMouseOut = (e) => {
    setValue({ name: 'rate', value: Number(star) });
  };

  const onClick = (e) => {
    setValue({ name: 'star', value: Number(e.target.id) });
  };

  const onAgreeCheck = () => {
    setValue({ name: 'marketingAgree', value: !marketingAgree });
  };

  const {
    thumbnail,
    itemName,
    createDateTime,
    reviewImageIdsToDelete,
    marketingAgree,
    star,
    text,
    blogUrl,
    communityUrl,
    facebookUrl,
    instagramUrl,
    toMypage,
    reviewImages,
    defaultImages,
    previewReviewImages,
    isLoading,
  } = state;

  return {
    onMouseOver,
    onMouseOut,
    onClick,
    onAgreeCheck,
    onCreateReview,
    onAddImageList,
    onDeleteAddImage,
    onDeleteDefaultImage,
    onChange,
    thumbnail,
    itemName,
    createDateTime,
    marketingAgree,
    star,
    text,
    blogUrl,
    communityUrl,
    facebookUrl,
    instagramUrl,
    toMypage,
    defaultImages,
    previewReviewImages,
    reviewCategoryType,
    isLoading,
  };
};

const REVIEW_WRITE_INITIAL_STATE = {
  reviewImages: [],
  previewImages: [],
  itemName: '',
  createDateTime: '',
  rate: 5,
  star: 5,
  communityUrl: '',
  blogUrl: '',
  instagramUrl: '',
  facebookUrl: '',
  text: '',
  images: [],
  toMypage: false,
  storageUri: '',
  reviewImageIdsToDelete: '',
  isLoading: false,
  defaultImages: [],
};

export const useGetReviewList = () => {
  const [state, , , setValueAll] = Reducer(REVIEW_LIST_INITIAL_STATE);
  const { totalLikes, userReviews } = state;

  useEffect(() => {
    api.getCurrentUserReview().then((response) => {
      setValueAll({
        object: {
          userReviews: response.data,
          totalLikes: response.data
            .map((item) => item.likesCount)
            .reduce((prev, curv) => prev + curv, state.totalLikes),
        },
      });
    });
  }, []);

  return { totalLikes, userReviews };
};

const REVIEW_LIST_INITIAL_STATE = {
  userReviews: [],
  totalLikes: 0,
};

export const useGetReviewCount = () => {
  const [reviewCount, setReviewCount] = useState(0);

  useEffect(() => {
    api
      .getReviewCount()
      .then((response) => {
        setReviewCount(response.data);
      })
      .catch((e) => {
        alert(ERROR_REFRESH);
      });
  }, []);

  return { reviewCount };
};
